import { RecentlyViewed } from '@theme/recently-viewed-products';

/** Llena la fila de "Vistos recientemente" con las tarjetas del tema; sin nada que mostrar, sigue oculta. */
class DlfRecentlyViewed extends HTMLElement {
  async connectedCallback() {
    let ids = [];
    try {
      ids = RecentlyViewed.getProducts().filter((/** @type {string} */ id) => id !== this.dataset.currentId);
    } catch {
      return; // localStorage bloqueado
    }
    if (ids.length === 0) return;

    const url = new URL(this.dataset.url || '/search', location.origin);
    url.searchParams.set('view', 'dlf-recent');
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', ids.map((/** @type {string} */ id) => `id:${id}`).join(' OR '));

    let html = '';
    try {
      const response = await fetch(url);
      if (!response.ok) return;
      html = await response.text();
    } catch {
      return;
    }

    const doc = new DOMParser().parseFromString(html, 'text/html');
    if (doc.querySelectorAll('.dlf-rv__item').length === 0) return;

    // Shopify agrega rastreo de búsqueda a las ligas: fuera, estos clics no son búsquedas
    doc.querySelectorAll('.dlf-rv__item a[href]').forEach((link) => {
      const href = new URL(link.getAttribute('href') || '', location.origin);
      ['_pos', '_sid', '_ss'].forEach((param) => href.searchParams.delete(param));
      link.setAttribute('href', href.pathname + href.search);
    });

    const row = this.querySelector('[data-rv-row]');
    if (!row) return;
    // Los productos ya no publicados no regresan en la búsqueda, así que aquí solo llega lo que sigue a la venta
    row.replaceChildren(...doc.body.querySelectorAll('style, .dlf-rv__item'));
    this.hidden = false;
    this.#setupArrows(row);
  }

  /** @param {Element} row */
  #setupArrows(row) {
    const arrows = this.querySelector('[data-rv-arrows]');
    if (!(arrows instanceof HTMLElement)) return;
    const buttons = arrows.querySelectorAll('button');

    const update = () => {
      const max = row.scrollWidth - row.clientWidth;
      arrows.hidden = max <= 1;
      buttons.forEach((button) => {
        const dir = Number(button.dataset.rvDir);
        button.disabled = dir < 0 ? row.scrollLeft <= 1 : row.scrollLeft >= max - 1;
      });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        row.scrollBy({ left: Number(button.dataset.rvDir) * row.clientWidth, behavior: 'smooth' });
      });
    });
    row.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(row);
    update();
  }
}

if (!customElements.get('dlf-recently-viewed')) customElements.define('dlf-recently-viewed', DlfRecentlyViewed);
